export default {
  availableGames: null, // "lovligt vilt"
  games: null // "jaktbart vilt"
}
